import React from 'react';
import Helmet from 'react-helmet';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import './notFound.scss';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="ui container not-found">
            <Helmet title="Puslapis nerastas" />
            <Result
                status="404"
                title="404"
                subTitle="Atsiprašome, puslapio, kurio ieškote, neradome."
                extra={(
                    <Button type="primary" onClick={() => navigate('/')}>
                        Grįžti į pradžią
                    </Button>
                )} />
        </div>
    );
};

export default NotFound;
